// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#maneuver-detection-table {
  line-height: 1; /* increase spacing between rows */
  font-size: 14px; /* bigger font */
}

#maneuver-detection-table td,
#maneuver-detection-table th {
  text-align: center;
  padding: 8px 12px; /* more horizontal and vertical padding */
}

#maneuver-detection-table th {
  font-weight: bold;
  text-decoration: underline;
}

#pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* make it span the full width */
  text-align: center; /* ensure text centering works */
  margin-top: 10px;
}

.highlight-red {
  background-color: #e51c23 !important;
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/orbit-guard-menu/orbit-guard-menu.css"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE,kCAAkC;EAClD,eAAe,EAAE,gBAAgB;AACnC;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB,EAAE,yCAAyC;AAC9D;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,gCAAgC;EAC7C,kBAAkB,EAAE,gCAAgC;EACpD,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB","sourcesContent":["#maneuver-detection-table {\n  line-height: 1; /* increase spacing between rows */\n  font-size: 14px; /* bigger font */\n}\n\n#maneuver-detection-table td,\n#maneuver-detection-table th {\n  text-align: center;\n  padding: 8px 12px; /* more horizontal and vertical padding */\n}\n\n#maneuver-detection-table th {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n#pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%; /* make it span the full width */\n  text-align: center; /* ensure text centering works */\n  margin-top: 10px;\n}\n\n.highlight-red {\n  background-color: #e51c23 !important;\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
